module.exports = __webpack_public_path__ + "assets/img/antzemine-elektrines.9aa34d68.jpg";